import React from "react";

const ICON_COLORS = {
  check: "#5c4096",
  users: "#44a7db",
  upload: "#5c4096",
  cash: "#226D96",
  exchange: "#44a7db",
};
const ICONS = {
  check: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
      <path
        d="M8 12l3 3 5-6"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  users: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <circle cx="9" cy="7" r="4" stroke="currentColor" strokeWidth="2" />
      <path
        d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  ),
  upload: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4M17 8l-5-5-5 5M12 3v12"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  cash: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <rect
        x="2"
        y="6"
        width="20"
        height="12"
        rx="2"
        stroke="currentColor"
        strokeWidth="2"
      />
      <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2" />
    </svg>
  ),
  exchange: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        d="M17 1l4 4-4 4M3 11V9a4 4 0 014-4h14M7 23l-4-4 4-4M21 13v2a4 4 0 01-4 4H3"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
};

const ChoiceCard = ({ data, onSelect, disabled }) => {
  if (!data?.Options?.length) return null;

  return (
    <div className="nav-card choice-card">
      <div className="choice-options">
        {data.Options.map((opt, i) => (
          <button
            key={i}
            className="choice-option"
            onClick={() => onSelect(opt.Value)}
            disabled={disabled}
          >
            <span
              className="choice-icon"
              style={{
                background: `${ICON_COLORS[opt.Icon] || "#5c4096"}15`,
                color: ICON_COLORS[opt.Icon] || "#5c4096",
              }}
            >
              {ICONS[opt.Icon] || ICONS.check}
            </span>
            <span className="choice-text">
              <strong className="choice-title">{opt.Title}</strong>
              {opt.Subtitle && (
                <small className="choice-subtitle">{opt.Subtitle}</small>
              )}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default ChoiceCard;
